import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export default function EyeAbleScript() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Script src="https://cdn.eye-able.com/configs/jobs.eon.com.js" strategy="lazyOnload" /><Script src="https://cdn.eye-able.com/testing2/public/js/eyeAble.js" strategy="lazyOnload" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}